module.exports = "<div>\n  <equipment-list></equipment-list>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/block/block-equipments/template.html
// module id = IZQL
// module chunks = 0